import { getLocalJitsiVideoTrack } from '../../react/features/base/tracks/functions';
import React from 'react';

import { showCustomNotification } from '../components/notifications';

import {
    WizyconfNotification,
    NotificationTemplate
} from './components/notifications';
import {
    NOTIFICATION_HIDE_TIMEOUT,
    CAMERA_ON_CLASSNAME,
    CAM_CON_ICON_CLASSNAME,
    CAMERA_OFF_CLASSNAME
} from './constants';
import CameraModeNotification from './modules/cameraModeNotification';

export default class CameraControll {

    static PTZ_CONTROL_ENABLED = false;
    static IS_CONTROL_ENABLED = false;
    static CAMERA_TOGGLED = false;

    _cameraControlEnableInstance = null;
    _cameraControlAutoInstance = null;
    _cameraControlDisableInstance = null;
    _cameraControlFailedInstance = null;
    _showCustomNotificationInstance = null;

    constructor() {
        this.cameraModeNotification = new CameraModeNotification();
        this._cameraControlEnableInstance = this.onEnable.bind(this);
        this._cameraControlAutoInstance = this.onAutoMode.bind(this);
        this._cameraControlDisableInstance = this.onDisable.bind(this);
        this._cameraControlFailedInstance = this.onFailed.bind(this);
        this._showCustomNotificationInstance = this.zoomNotification.bind(this);

        window.addEventListener('cameraControlEnable', this._cameraControlEnableInstance, false);
        window.addEventListener('cameraControlAuto', this._cameraControlAutoInstance, false);
        window.addEventListener('cameraControlDisable', this._cameraControlDisableInstance, false);
        window.addEventListener('cameraControlFailed', this._cameraControlFailedInstance, false);
        window.addEventListener('showCustomNotification', this._showCustomNotificationInstance, false);

        this.ifModeAuto = false;
        this.autoFrameEnabled = false;
    }

    zoomNotification(event) {
        const { detail } = event;

        APP.store.dispatch(showCustomNotification({
            titleKey: 'strings.PTZCameraControllMode',
            customClass: CameraControll.IS_CONTROL_ENABLED ? 'animate' : '',
            description:
                <NotificationTemplate key={0}
                    firstLine={{ text: 'strings.On' }}
                    secondLine={detail?.dataNotification}
                    iconClass={`${CAMERA_ON_CLASSNAME} ${CAM_CON_ICON_CLASSNAME}`}/>
        }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
    }

    toggleTrackingMode(stateValue) {

        const localVideo = getLocalJitsiVideoTrack(APP.store.getState());

        this.ifModeAuto = stateValue;

        if (!localVideo) {
            return false;
        }

        if (this.isCameraCanAutoFraming()) {
            if (this.autoFrameEnabled !== stateValue) {
                localVideo.track.applyConstraints({ advanced: [ { autoFraming: stateValue } ] });
            }
            this.autoFrameEnabled = stateValue;
        } else {
            localVideo.track.applyConstraints({ advanced: [ { audioTracking: stateValue } ] });
        }
    }

    onAutoMode() {
        if (this.isCameraCanAutoFraming() || this.isCameraCanAutoTracking()) {
            CameraControll.IS_CONTROL_ENABLED = true;
            const secondLineObj = this.isCameraHaveUpdate() ? { text: 'strings.CameraHaveUpdate' } : null;

            this.cameraModeNotification.show({
                title: 'strings.Auto',
                customClass: 'color-yellow'
            });

            APP.store.dispatch(showCustomNotification({
                titleKey: 'strings.PTZCameraControllMode',
                customClass: 'animate',
                description:
                    <NotificationTemplate key={0} firstLine={{ text: 'strings.Auto' }}
                        secondLine={secondLineObj}
                        iconClass={`${CAMERA_ON_CLASSNAME} ${CAM_CON_ICON_CLASSNAME}`}/>
            }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));

            setTimeout(() => {
                if (this.ifModeAuto) {
                    this.toggleTrackingMode(true);
                    CameraControll.PTZ_CONTROL_ENABLED = false;
                }
            }, NOTIFICATION_HIDE_TIMEOUT);
            this.ifModeAuto = true;
        } else if (!this.isCameraCanAutoTracking()) {
            CameraControll.IS_CONTROL_ENABLED = false;
            APP.store.dispatch(showCustomNotification({
                titleKey: 'strings.PTZCameraControllMode',
                description:
                    <NotificationTemplate key={0}
                        firstLine={{ text: 'strings.Auto',
                            color: 'color-gray' }}
                        secondLine={{ text: 'strings.AutoDisabled' }}
                        iconClass={`${CAMERA_OFF_CLASSNAME} ${CAM_CON_ICON_CLASSNAME}`}/>
            }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
        }
    }

    isCameraCanAutoTracking() {
        const localTrack = getLocalJitsiVideoTrack(APP.store.getState());

        return localTrack && localTrack.track.getSettings().audioTracking !== undefined;
    }

    isCameraCanAutoFraming() {
        const localTrack = getLocalJitsiVideoTrack(APP.store.getState());

        return localTrack && localTrack.track.getSettings().autoFraming !== undefined;
    }

    isCameraHaveUpdate() {
        const localTrack = getLocalJitsiVideoTrack(APP.store.getState());

        return localTrack && localTrack.track.getSettings().upgradeState !== undefined
            && localTrack.track.getSettings().upgradeState.indexOf('available') !== -1;
    }

    onEnable() {
        CameraControll.IS_CONTROL_ENABLED = true;
        const objText = {
            text: 'strings.ZoomPtz',
            color: 'color-white'
        };

        this.cameraModeNotification.show({
            title: 'strings.On',
            customClass: 'color-yellow'
        });
        APP.store.dispatch(showCustomNotification({
            titleKey: 'strings.PTZCameraControllMode',
            customClass: 'animate',
            description:
                <NotificationTemplate key={0}
                    firstLine={{ text: 'strings.On' }}
                    secondLine={this.isCameraCanAutoFraming() ? objText : {}}
                    iconClass={`${CAMERA_ON_CLASSNAME} ${CAM_CON_ICON_CLASSNAME}`}/>
        }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
        this.toggleTrackingMode(false);
        CameraControll.PTZ_CONTROL_ENABLED = true;
    }

    onDisable() {
        if (!CameraControll.CAMERA_TOGGLED) {
            APP.store.dispatch(showCustomNotification({
                titleKey: 'strings.PTZCameraControllMode',
                customClass: 'animate',
                description:
                    <NotificationTemplate key={0}
                        firstLine={{ text: 'strings.Off',
                            color: 'color-gray' }}
                        iconClass={`${CAMERA_OFF_CLASSNAME} ${CAM_CON_ICON_CLASSNAME}`}/>
            }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
        }

        this.toggleTrackingMode(false);
        this.cameraModeNotification.show({
            title: 'strings.Off',
            customClass: 'color-gray'
        }, NOTIFICATION_HIDE_TIMEOUT);
        CameraControll.PTZ_CONTROL_ENABLED = false;
        CameraControll.IS_CONTROL_ENABLED = false;
        CameraControll.CAMERA_TOGGLED = false;
    }

    onFailed() {
        if (CameraControll.IS_CONTROL_ENABLED) {
            this.cameraModeNotification.show({
                title: 'strings.Off',
                customClass: 'color-gray'
            }, NOTIFICATION_HIDE_TIMEOUT);
        }

        APP.store.dispatch(showCustomNotification({
            titleKey: 'error.PTZCameraControllFailed',
            customClass: CameraControll.IS_CONTROL_ENABLED ? 'animate' : ''
        }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
        CameraControll.PTZ_CONTROL_ENABLED = false;
        CameraControll.IS_CONTROL_ENABLED = false;
    }

    destroy() {
        window.removeEventListener('cameraControlEnable', this._cameraControlEnableInstance, false);
        window.removeEventListener('cameraControlAuto', this._cameraControlAutoInstance, false);
        window.removeEventListener('cameraControlDisable', this._cameraControlDisableInstance, false);
        window.removeEventListener('cameraControlFailed', this._cameraControlFailedInstance, false);
        window.removeEventListener('showCustomNotification', this._showCustomNotificationInstance, false);

        this._cameraControlEnableInstance = null;
        this._cameraControlAutoInstance = null;
        this._cameraControlDisableInstance = null;
        this._cameraControlFailedInstance = null;
        this._showCustomNotificationInstance = null;
    }

}
